import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const AutomobilePremiumFinanceListWarpper = Loadable(
  lazy(() =>
    import(
      "./AutonobilePremiumFinanceListWrapper"
    ).then(({ AutomobilePremiumFinanceListWarpper }) => ({
      default: AutomobilePremiumFinanceListWarpper,
    }))
  )
);
const Premium = Loadable(
  lazy(() =>
    import("./AutomobilePremiumFinance").then(
      ({ AutomobilePremiumFinance }) => ({
        default: AutomobilePremiumFinance,
      })
    )
  )
);

export const AutomobilePremiumFinanceRoutes = [
  {
    path: `/automobile-policy/:customerId/premium-finance/:customerPolicyId/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <AutomobilePremiumFinanceListWarpper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/automobile-policy/:customerId/premium-finance/:customerPolicyId/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Premium />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/automobile-policy/:customerId/premium-finance/:customerPolicyId/manage/:premiumNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Premium />
      </AuthorizedRoute>
    ),
  },
];
